import styled from 'styled-components';
import classNames from 'classnames';
import media from '../media-queries';
import { LinkButton } from '../link-button';
import { MenuLink, ShopLink } from './menu-link';

const Outer = styled.div`
  background-color: ${(props) => props.theme.colours.white};
  color: ${(props) => props.theme.colours.primary};
  justify-content: center;
  display: none;
  ${media.lg} {
    z-index: 10;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
`;

export const Inner = styled.div``;

export const Container = ({ className, children }) => {
  const containerClasses = classNames(className);
  return (
    <Outer className={containerClasses}>
      <Inner>{children}</Inner>
    </Outer>
  );
};

const List = styled.div`
  margin: 0;
  width: 100%;
  font-family: ${(props) => props.theme.typography.heading.font};

  ${media.md} {
    display: flex;
    justify-content: space-between;
  }

  .menu__list-item:last-child {
    margin-right: 0;
  }
`;

const LinkButtonWrapper = styled.div`
  margin: 0;
  padding: 10px 0;

  a {
    font-size: 1rem;
  }

  ${media.lg} {
    margin: 2px 0;
    a {
      font-size: 1.1rem;
    }
  }

  ${media.xl} {
    a {
      font-size: 1.2rem;
    }
  }
`;

export const Menu = (props) => {
  const containerClasses = classNames(`menu`, props.className);
  return (
    <Container className={containerClasses}>
      <List className={`menu__list`}>
        <MenuLink
          className={`menu__list-item`}
          title='How we help'
          to='/how-we-help'
        >
          How we help
        </MenuLink>
        <MenuLink
          className={`menu__list-item`}
          title='Support us'
          to='/support-us'
        >
          Support us
        </MenuLink>
        <MenuLink className={`menu__list-item`} title='Train' to='/training'>
          Train
        </MenuLink>
        <MenuLink
          className={`menu__list-item`}
          title='Volunteer'
          to='/volunteer'
        >
          Volunteer
        </MenuLink>
        <MenuLink
          className={`menu__list-item`}
          title='Request help'
          to='/request-help'
        >
          Request help
        </MenuLink>
        <MenuLink
          className={`menu__list-item`}
          title='Membership'
          to='/support-us/membership'
        >
          Membership
        </MenuLink>
        <MenuLink className={`menu__list-item`} title='News' to='/news'>
          News
        </MenuLink>
        <MenuLink className={`menu__list-item`} title='About us' to='/about-us'>
          About us
        </MenuLink>
        <ShopLink
          className={`menu__list-item`}
          href='https://wvsshop.org.uk/'
          target='_blank'
          title='Shop'
        >
          Shop
        </ShopLink>
        <LinkButtonWrapper>
          <LinkButton
            className={`menu__list-item highlight`}
            colour='tertiary'
            title='Donate'
            to='/donate'
          >
            Donate
          </LinkButton>
        </LinkButtonWrapper>
      </List>
    </Container>
  );
};
